import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInfo, SessionService } from './session.service';
import { _common } from './_common';

@Component({
  selector: 'app-signup-confirmed',
  templateUrl: './signup.confirmed.component.html'
})
export class SignupConfirmedComponent implements OnInit {


  _common = _common;
  appName: string;
  app: AppInfo;
  endpoint: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,

  ) {
    this.route.queryParams.subscribe((params) => {

      this.appName = params.app;
      this.endpoint = params.endpoint;
      this.app = SessionService.APPS.find((c) => c.id == this.appName);

    })
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }



}
